<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" md="12" lg="12" xl="12">
        <h5 class="mb-0">{{ $t("Фойда сверкаси")}}</h5>
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">{{ $t("Вақт") }} 1</label>
        <input class="form-control" type="date" v-model="datas.date1" />
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">{{ $t("Вақт") }} 2</label>
        <input class="form-control" type="date" v-model="datas.date2" />
      </b-col>
      <b-col lg="2" class="my-1">
        <label>Склад</label>
        <v-select
          :clearable="false"
          class="form-control-sm md-input"
          :options="skladlist"
          v-model="datas.sklad_id"
          :reduce="name => name.id"
          label="name"
        >
        <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  aria-activedescendant="null"
                />
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
              </template>
        </v-select>
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">Товар</label>
        <v-select
          :clearable="false"
          class="form-control-sm"
          v-if="productlist != null"
          @search="query => (search = query)"
          :options="paginated"
          v-model="datas.product_id"
          :filter-by="$store.state.myFilter"
          :reduce="extra_name => extra_name.id"
          label="extra_name"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"></span>
            <button
              type="button"
              class="modallist"
              @click="Selectproduct(null)"
            >
              <b-icon icon="three-dots"></b-icon>
            </button>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em
                ><b>{{ search }}</b></em
              >
              {{ $t("бўйича маьлумот йўқ") }}
            </template>
            <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </b-col>
      <b-col lg="4" class="my-1">
        <br /><button type="button" class="btn mybtn" @click="Send()">
          {{ $t("Кўриш") }}
        </button>
        <button type="button" class="btn mybtn" @click="downloadExl">
          <b-icon icon="cloud-download"></b-icon> {{ $t("Excel(Юклаш)") }}
        </button>
        <button type="button" class="btn mybtn" @click="Print()">
          <b-icon icon="printer"></b-icon>
        </button>
      </b-col>
      <div class="limiter" id="tableId">
        <div class="container-table100">
          <div class="wrap-table100">
            <div class="table100 ver1 m-b-110" style="padding-top:47px!important">
              <div class="table100-head">
                <table>
                  <thead>
                    <tr class="row100 head">
                      <th class="cell100 column0">#</th>
                      <th class="cell100 column2-5">{{ $t("Номи") }}</th>
                      <th class="cell100 column2">{{ $t("Вақт") }}</th>
                      <th class="cell100 column1">{{ $t("Кол.") }}</th>
                      <th class="cell100 column2">{{ $t("Тан нарх") }}</th>
                      <th class="cell100 column2">
                        {{ $t("Тан нарх сумма") }}
                      </th>
                      <th class="cell100 column2">{{ $t("Сотиш нарх") }}</th>
                      <th class="cell100 column3">{{ $t("Сотиш сумма") }}</th>
                      <th class="cell100 column2">{{ $t("Фойда нарх") }}</th>
                      <th class="cell100 column1">{{ $t("Фойда") }} %</th>

                      <th class="cell100 column2">{{ $t("Фойда сумма") }}</th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="table100-body summatable">
                <table>
                  <tr>
                    <td class="cell100 column5" colspan="3">
                      {{ $t("Бошланғич қолдиқ") }}
                    </td>
                    <td class="cell100 column1 kol">
                      <span v-if="results.begin">{{
                        results.begin.balance | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column4 kol" colspan="2">
                      <span v-if="results.begin">{{
                        results.begin.total_body_summa | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column5 kol" colspan="2">
                      <span v-if="results.begin">{{
                        results.begin.total_sold_summa | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column3 kol" colspan="2">
                      <span v-if="results.begin">{{
                        results.begin.total_profit_percent | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column2 kol">
                      <span v-if="results.begin">{{
                        results.begin.total_profit_summa | numFormats
                      }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="table100-body sverka js-pscroll">
                <table>
                  <tbody>
                    <tr
                      class="row100 body"
                      v-for="(item, index) in results.data"
                      :key="index"
                    >
                      <td class="cell100 column0">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ index + 1 }}</router-link
                        >
                      </td>
                      <td class="cell100 column2-5">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ item.doc_type }} № {{ item.doc_id }}</router-link
                        >
                      </td>
                      <td class="cell100 column2">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ Datetime(item.datetime) }}</router-link
                        >
                      </td>
                      <td class="cell100 column1 kol">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ item.count | numFormats }}</router-link
                        >
                      </td>
                      <td class="cell100 column2 kol">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ item.body_price | numFormats }}</router-link
                        >
                      </td>
                      <td class="cell100 column2 kol">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ item.body_summa | numFormats }}</router-link
                        >
                      </td>
                      <td class="cell100 column2 kol">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ item.sold_price | numFormats }}</router-link
                        >
                      </td>
                      <td class="cell100 column3 kol">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ item.sold_summa | numFormats }}</router-link
                        >
                      </td>
                      <td class="cell100 column2 kol">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ item.profit_price | numFormats }}</router-link
                        >
                      </td>
                      <td class="cell100 column1 kol">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >
                          <span v-if="parseInt(item.profit_percent)>=0">
                          {{ parseFloat(item.profit_percent).toFixed(0) }}
                        </span>
                        <span v-else>
                          0
                        </span>
                        </router-link>
                      </td>
                      <td class="cell100 column2 kol">
                        <router-link
                          target="_blank"
                          :to="{
                            name: item.doc_type + ' ўзгартириш',
                            params: { id: item.doc_id }
                          }"
                          >{{ item.profit_summa | numFormats }}</router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table100-body summatable1">
                <table>
                  <tr>
                    <td colspan="3" class="cell100 column5">{{ $t("Жами") }}</td>
                    <td class="cell100 column1 kol">
                      <span v-if="results.summ">{{
                        results.summ.balance | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column4 kol" colspan="2">
                      <span v-if="results.summ">{{
                        results.summ.total_body_summa | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column5 kol" colspan="2">
                      <span v-if="results.summ">{{
                        results.summ.total_sold_summa | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column3 kol" colspan="2">
                      <span v-if="results.summ && parseInt(results.summ.total_profit_percent)>=0">{{
                        parseFloat(results.summ.total_profit_percent).toFixed(0)
                      }}</span>
                      <span v-else>
                        0
                      </span>
                    </td>
                    <td class="cell100 column2 kol">
                      <span v-if="results.summ">{{
                        results.summ.total_profit_summa | numFormats
                      }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="table100-body summatable">
                <table>
                  <tr>
                    <td colspan="3" class="cell100 column5 ">
                      {{ $t("Якуний қолдиқ") }}
                    </td>
                    <td class="cell100 column1 kol">
                      <span v-if="results.end">{{
                        results.end.balance | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column4 kol" colspan="2">
                      <span v-if="results.end">{{
                        results.end.total_body_summa | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column5 kol" colspan="2">
                      <span v-if="results.end">{{
                        results.end.total_sold_summa | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column3 kol" colspan="2">
                      <span v-if="results.end && parseInt(results.end.total_profit_percent)>=0">{{
                        parseFloat(results.end.total_profit_percent).toFixed(0)
                      }}</span>
                      <span v-else>0</span>
                    </td>
                    <td class="cell100 column2 kol">
                      <span v-if="results.end">{{
                        results.end.total_profit_summa | numFormats
                      }}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-row>
    <sklad :datas="datas"></sklad>
  </b-container>
</template>

<script>
var XLSX = require("xlsx");
import { print } from "../../../components/mixins/print.js";
var FileSaver = require("file-saver");
import { Sklad } from "@/pages";
export default {
  components: { Sklad },
  data() {
    return {
      datas: {
        date1: new Date().toISOString().slice(0, 8) + "01",
        date2: new Date().toISOString().slice(0, 10),
        product_id: 0,
        sklad_id: parseInt(localStorage.getItem("sklad_id"))
      },
      sklad: "",
      skladlist: [],
      errors: "",
      results: []
    };
  },
  mixins: [print],
  mounted: function() {
    let self = this;
    self.$root.$on("skladone", function(getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
      (window.onstorage = () => {
        if (localStorage.getItem("setted_product") > 0) {
          self.Productlist();
          self.datas.product_id = parseInt(
            localStorage.getItem("setted_product")
          );
          localStorage.setItem("setted_product", 0);
        }
      }),
        setTimeout(() => {
          localStorage.setItem("sklad_id_dok", self.datas.sklad_id);
          localStorage.setItem("created_at_dok", self.datas.date2);
        }, 1000);
    });
  },
  created: function() {
    let self = this;
    if (this.$route.params.date1 != "null") {
      self.datas.date1 = this.$route.params.date1;
      self.datas.date2 = this.$route.params.date2;
      self.datas.sklad_id = parseInt(this.$route.params.sklad);
      self.datas.product_id = parseInt(this.$route.params.product);
      self.Send();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (localStorage.getItem("product_id") != null) {
      localStorage.removeItem("product_id");
      localStorage.removeItem("date1");
      localStorage.removeItem("date2");
      localStorage.removeItem("sklad_id");
    }
    next();
  },
  methods: {
    Selectproduct(index) {
      this.$store.state.selected_index = index;
      let routeData = this.$router.resolve({ name: "Товар модал" });
      window.open(routeData.href, "_blank", "width=1200, height=1000");
    },
    downloadExl() {
      this.$store.state.xls=true;
      setTimeout(() => {
        let wb = XLSX.utils.table_to_book(document.getElementById("tableId")),
        wopts = {
          bookType: "xlsx",
          bookSST: false,
          type: "binary"
        };
        var wscols = [{ width: 5 },{ width: 20 },{ width: 15 },{ width: 10 },{ width: 15 },{ width: 15 },{ width: 15 },{ width: 15 },{ width: 15 },{ width: 15 },{ width: 15 }]; 
        wb.Sheets.Sheet1['!cols']=wscols;
        let wbout = XLSX.write(wb, wopts);
      FileSaver.saveAs(
        new Blob([this.s2ab(wbout)], {
          type: "application/octet-stream;charset=utf-8"
        }),
        new Date() + "foyda_sverka.xlsx"
      );
      setTimeout(() => {
        this.$store.state.xls=false;
      }, 1000);
      }, 2000);
    },
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefind") {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    },
    Send() {
      let self = this;
      var datas = {
        datetime1: parseInt(
          new Date(self.datas.date1)
            .valueOf()
            .toString()
            .slice(0, 10)
        ),
        datetime2:
          parseInt(
            new Date(self.datas.date2)
              .valueOf()
              .toString()
              .slice(0, 10)
          ) + 86399,
        sklad_id: self.datas.sklad_id,
        product_id: self.datas.product_id
      };
      axios({
        method: "post",
        url: "api/v1/akt-sverka/profit",
        headers: {
          "Content-Type": "application/json"
        },
        data: datas
      }).then(function(response) {
        self.results = response.data;
        self.results.summ = {
          balance: 0,
          total_body_summa: 0,
          total_sold_summa: 0,
          total_profit_percent: 0,
          total_profit_summa: 0
        };
        self.results.data.forEach(function(key, value) {
          self.results.summ.balance += parseFloat(key.count);
          self.results.summ.total_body_summa += parseFloat(key.body_summa);
          self.results.summ.total_sold_summa += parseFloat(key.sold_summa);
          self.results.summ.total_profit_summa += parseFloat(key.profit_summa);
        });
        self.results.summ.total_profit_percent +=
          (self.results.summ.total_profit_summa /
            self.results.summ.total_body_summa) *
          100;
      });
    }
  }
};
</script>
<style scoped>
.table100-body {
  max-height: 440px;
}
</style>
